import type  { Package } from "../components";

export function readmeCleanser(packageData: Package) {
    if (!packageData.readMeContent || packageData.readMeContent.length === 0) {
        return;
    }

    // make links relative
    packageData.readMeContent = packageData.readMeContent.replace(
        /(https:\/\/)?marketplace\.umbraco\.com/g,
        ''
    );

    const regex = new RegExp(`^<h\\d.*?>(?:${packageData.title}).*<\\/h\\d.*?>`, 'i');
    packageData.readMeContent = packageData.readMeContent.replace(regex, '');
}
